import {VIEW_MESSAGE} from "../../reducers/editMessageReducer";
export const viewMessage = () =>{
    return {
        type: VIEW_MESSAGE,
        payload: {}
    }
}